import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/services/user.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-site-layout',
  templateUrl: './site-layout.component.html',
  styleUrls: ['./site-layout.component.css']
})
export class SiteLayoutComponent implements OnInit {

  public styleParticles: object = {};
  public paramsParticles: object = {};
  
  public teacher: any[];

  constructor(private userService: UserService) { }

  ngOnInit() {
    
    this.styleParticles = {
      'position': 'absolute',
      'width': '100%',
      'height': '100%',    
      'top': 0,
      'left': 0,
      'right': 0,
      'bottom': 0,
      'background': 'rgba(0, 0, 0, .4)',           
    };

    this.paramsParticles = {
      particles: {
        number: {
          value: 200,
          density: {
            enable: true,
            value_area: 2000
          }
        },
        color: {
          value: '#fff'
        },
        shape: {
          type: 'stars',
        },
        move: {
          random: true,
          speed: 10,
          out_mode: 'bounce'
        }
       
      }
    };     

    this.loadListTeacher();
  }

  public loadListTeacher() {
    this.userService.getAllTeacherToCarousel()
    .subscribe(result => {
      this.teacher = result.data;
    });
  }

  

}
